import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Search } from "lucide-react";
import { DECISION_LABELS } from "./pilotUtils";

export function PilotsFilters({
  searchTerm, setSearchTerm,
  decisionFilter, setDecisionFilter,
  partnerFilter, setPartnerFilter,
  partners, filteredCount, total,
}) {
  const hasActive = searchTerm || decisionFilter !== "all" || partnerFilter !== "all";

  return (
    <Card>
      <CardContent className="pt-6 space-y-3">
        <div className="flex flex-col md:flex-row gap-3 items-center">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              placeholder="Buscar por nombre, objetivo, hipotesis, partner..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
              data-testid="pilots-search"
            />
          </div>
          <Select value={decisionFilter} onValueChange={setDecisionFilter}>
            <SelectTrigger className="w-[160px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Estado / Decision</SelectItem>
              {Object.entries(DECISION_LABELS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={partnerFilter} onValueChange={setPartnerFilter}>
            <SelectTrigger className="w-[160px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Partner</SelectItem>
              {partners.map(p => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        {hasActive && (
          <div className="flex items-center gap-2">
            <p className="text-xs text-muted-foreground">{filteredCount} de {total} pilotos</p>
            <Button
              variant="ghost"
              size="sm"
              className="h-6 text-xs"
              onClick={() => { setSearchTerm(""); setDecisionFilter("all"); setPartnerFilter("all"); }}
            >
              Limpiar filtros
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
